import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useLanguage } from "../context/LanguageContext";
import { toast } from "sonner";
import { Loader2, ChevronRight } from "lucide-react";

export default function AdminUsers() {
  const { t, translateError } = useLanguage();
  const navigate = useNavigate();
  const [users, setUsers] = useState(null);

  useEffect(() => {
    api.get("/admin/users")
      .then(({ data }) => setUsers(data))
      .catch((e) => { toast.error(translateError(formatApiError(e.response?.data?.detail)) || t("adminUsers.loadError")); setUsers([]); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!users) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <main className="relative z-10 mx-auto max-w-6xl px-6 py-14 md:px-10">
      <span className="font-mono text-xs uppercase tracking-widest text-primary">{t("adminUsers.eyebrow")}</span>
      <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter sm:text-5xl">{t("adminUsers.title")}</h1>
      <p className="mt-3 text-muted-foreground">{t("adminUsers.subtitle", { n: users.length })}</p>

      <div className="mt-8 overflow-hidden border border-white/10">
        <table className="w-full text-sm" data-testid="admin-users-table">
          <thead className="border-b border-white/10 bg-card">
            <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
              <th className="p-4">{t("adminUsers.colName")}</th>
              <th className="p-4">{t("adminUsers.colEmail")}</th>
              <th className="p-4 text-right">{t("adminUsers.colCredits")}</th>
              <th className="p-4 text-right">{t("adminUsers.colPurchased")}</th>
              <th className="p-4 text-right">{t("adminUsers.colBets")}</th>
              <th className="p-4 text-right">{t("adminUsers.colComments")}</th>
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr
                key={u.id}
                onClick={() => navigate(`/admin/users/${u.id}`)}
                data-testid={`user-row-${u.id}`}
                className="cursor-pointer border-b border-white/5 transition-colors hover:bg-card"
              >
                <td className="p-4 font-medium">
                  {u.name || "—"}
                  {u.role === "admin" && (
                    <span className="ml-2 border border-primary/40 px-1.5 py-0.5 font-mono text-[9px] uppercase tracking-widest text-primary">{t("adminUsers.role")}</span>
                  )}
                </td>
                <td className="p-4 text-muted-foreground">{u.email}</td>
                <td className="p-4 text-right font-mono text-credit">{u.credits}</td>
                <td className="p-4 text-right font-mono">{u.total_credits_purchased}</td>
                <td className="p-4 text-right font-mono">{u.bets_count}</td>
                <td className="p-4 text-right font-mono">{u.comments_count}</td>
                <td className="p-4 text-right text-muted-foreground"><ChevronRight className="ml-auto h-4 w-4" /></td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr><td colSpan={7} className="p-12 text-center text-muted-foreground">—</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </main>
  );
}
